import { parse as parseYaml } from "yaml";

/**
 * Inlined YAML-frontmatter parser — mirrors memory-extended's own inlined copy.
 *
 * ontos ships as a public add-on, so it cannot import the internal, unpublished
 * `@vortex-os/core` `parseFrontmatter`. The single helper needed is inlined here
 * (only `yaml` is an external dependency). BOM-safe; returns empty frontmatter +
 * the source unchanged when no fence is present; tolerates a malformed fence by
 * treating it as no frontmatter.
 */
const FENCE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/;
const BOM = "﻿";

export interface FrontmatterDoc<T> {
  readonly frontmatter: T;
  readonly body: string;
}

export function parseFrontmatter<T = Record<string, unknown>>(source: string): FrontmatterDoc<T> {
  const cleaned = source.startsWith(BOM) ? source.slice(1) : source;
  const match = cleaned.match(FENCE);
  if (!match) {
    return { frontmatter: {} as T, body: cleaned };
  }
  const yaml = match[1] ?? "";
  const body = cleaned.slice(match[0].length);
  let parsed: T;
  try {
    parsed = (parseYaml(yaml) ?? {}) as T;
  } catch {
    parsed = {} as T;
  }
  return { frontmatter: parsed, body };
}
